import React, { Component } from 'react';
import DynamicTable from './DynamicTable';
import DailyCard from './DynamicCurrentDateCards';
import { getFinancialsData, getPlans } from '../../actions/financials';
import moment from 'moment';
import { Row } from 'react-bootstrap';

class FinPlanComp extends Component {
  constructor() {
    super();
    this.state = {
      planCard: ['date', 'time', 'money'],
      numberHeaders: ['Date', 'Default', 'Similar', 'Premium', 'VIP'],
      numberType: { free: 20, similar: 3, premium: 3, vip: 40 },
      planType: { plan1: 10, plan2: 30, plan3: 40 },
      plansFrom: null,
      plansTo: null,
      numbersFrom: null,
      numbersTo: null,
      plansReport: [],
      numbersReport: [],
      // plansReportToday: [],
      todaysNumberData: {},
      numbersReportToday: [],
      plansList: [],
      plansTitleList: [],
      numberData: [],
      planList: {},
      error: '',
      numberError: ''
    }
  }


  componentDidMount() {
    let fromDate = moment().subtract(10, 'days').format("YYYY-MM-DD");
    let tillDate = moment().format("YYYY-MM-DD");
    var todayStart = moment().format("YYYY-MM-DD");
    var todayEnd = moment().add(1, 'day').format("YYYY-MM-DD");

    var start = moment().startOf('day');
    var end = moment().endOf('day');
    var yesterdayEnd = moment().subtract(1, 'day').endOf('day');
    var yesterdayStart = moment().subtract(1, 'day').startOf('day');



    // var yesterday = moment().subtract(1, 'day').format('YYYY-MM-DD');

    getPlans()
      .then(resp => { return resp.response.plans })
      .then(resp => {
        let planTypes = {};
        for (const key of resp) {
          planTypes[key.plan_id] = key.plan_type
        }
        getFinancialsData({
          searchCategory: 'plan_count',
          from: fromDate,
          to: tillDate
        })
          .then(resp => { return resp.response.registrationStats })
          .then(resp => {
            let planData = [];
            // console.log('planTypes1', planTypes);
            resp.forEach(day => {
              let dayEntry = {};
              dayEntry.created_at = day.created_at;
              for (const keyOne in planTypes) {
                dayEntry[keyOne] = 0;
                for (const keyTwo of day.plan_count) {
                  if (keyOne == keyTwo.plan_id) {
                    dayEntry[keyOne] = keyTwo.count;
                  }
                }
              }
              planData.push(dayEntry);
            })
            // console.log('plansReport', planData);
            // console.log('plansList', planTypes);
            this.setState({ plansReport: planData, planList: planTypes })
          })
          .catch(err => console.log(err));
      })
      .catch(err => console.log(err));


    // Todays Data for plans 
    getFinancialsData({
      searchCategory: 'plan_count',
      from: fromDate, // todayStart,
      to: todayEnd  // todayEnd
    })
      .then(resp => { return resp.response.registrationStats })
      .then(resp => {

        console.log('resp', resp);
        let todaysData = {};
        for (const key of resp[0].plan_count) {
          todaysData[key.plan_id] = key.count
        }

        getPlans()
          .then(resp => { return resp.response.plans })
          .then(resp => {

            let a = resp.map(item => {
              return `${item.description} || ${item.plan_id}`;
            })
            let planTodayData = {};
            for (const key of resp) {
              let newKey = `${key.description}`
              let planId = key.plan_id;
              if (todaysData[planId]) {

                planTodayData[newKey] = todaysData[planId];
              }
              else {
                planTodayData[newKey] = 0;
              }
            }

            a.unshift('Date')
            console.log('planTodayData', planTodayData)
            this.setState({
              // plansList: resp,
              plansTitleList: a,
              planTodayData: planTodayData
            });
          })
          .catch(err => console.log(err));
      })
      .catch(err => console.log(err));

    getFinancialsData({
      searchCategory: 'virtual_number_count',
      from: fromDate,
      to: tillDate
    })
      .then(resp => { return resp.response.registrationStats })
      .then(resp => {
        let numberData = [];
        resp.forEach(day => {
          let todaysNumberData = {
            created_at: null,
            default: 0,
            similar: 0,
            premium: 0,
            vip: 0,
            respData: day
          };
          for (const key of day.default_number_count) {
            todaysNumberData.default = key.count;
          }
          for (const key of day.similar_number_count) {
            todaysNumberData.similar += key.count;
          }
          for (const key of day.premium_number_count) {
            todaysNumberData.premium += key.count;
          }
          for (const key of day.vip_number_count) {
            todaysNumberData.vip += key.count;
          }
          todaysNumberData.created_at = day.created_at;
          numberData.push(todaysNumberData);
        })
        this.setState({ numberData: numberData });

      })
      .catch(err => console.log(err));

    getFinancialsData({
      searchCategory: 'virtual_number_count',
      from: fromDate,
      to: todayEnd
    })
      .then(resp => { return resp.response.registrationStats })
      .then(resp => {
        let todaysNumberData = {
          default: 0,
          similar: 0,
          premium: 0,
          vip: 0,
        };
        for (const key of resp[0].default_number_count) {
          todaysNumberData.default = key.count;
        }
        for (const key of resp[0].similar_number_count) {
          todaysNumberData.similar += key.count;
        }
        for (const key of resp[0].premium_number_count) {
          todaysNumberData.premium += key.count;
        }
        for (const key of resp[0].vip_number_count) {
          todaysNumberData.vip += key.count;
        }
        this.setState({ todaysNumberData: todaysNumberData })
      })
      .catch(err => console.log(err));
  }


  updatePlansTodayData() {
    let a = {};

  }

  onChange = e => {
    this.setState({ [e.target.id]: e.target.value });
  };

  getPlansCountHandler = () => {

    let today = moment().format("YYYY-MM-DD");
    if (this.state.plansFrom == null || this.state.plansTo == null) return this.setState({ error: 'provide input dates' });
    if (this.state.plansFrom > this.state.plansTo) return this.setState({ error: 'from can not be greater than till data' });
    if (this.state.plansTo > today) return this.setState({ error: 'no future dates' });
    this.setState({ error: '', reportData: [] });


    console.log(this.state.plansFrom, this.state.plansFrom);
    // return;
    getFinancialsData({ searchCategory: 'plan_count', from: this.state.plansFrom, to: this.state.plansTo })
      // .then((resp) => {
      //   this.setState({ plansReport: resp.response.result })
      // })
      .then(resp => { return resp.response.registrationStats })
      .then(resp => {
        let planData = [];
        let planTypes = this.state.planList;
        // console.log('plandata2', planData);
        // console.log('planTypes2', planTypes);
        resp.forEach(day => {
          let dayEntry = {};
          dayEntry.created_at = day.created_at;
          for (const keyOne in planTypes) {
            dayEntry[keyOne] = 0;
            for (const keyTwo of day.plan_count) {
              if (keyOne == keyTwo.plan_id) {
                dayEntry[keyOne] = keyTwo.count;
              }
            }
          }
          planData.push(dayEntry);
        })
        // console.log('plansReport2', planData);
        // console.log('plansList', planTypes);
        this.setState({ plansReport: planData })
      })
      .catch(err => console.log(err));



  }

  getNumbersCountHandler = () => {

    let today = moment().format("YYYY-MM-DD");
    if (this.state.numbersFrom == null || this.state.numbersTo == null) return this.setState({ numberError: 'provide input dates' });
    if (this.state.numbersFrom > this.state.numbersTo) return this.setState({ numberError: 'from can not be greater than till data' });
    if (this.state.numbersTo > today) return this.setState({ numberError: 'no future dates' });
    this.setState({ numberError: '', numbersReport: [] });

    getFinancialsData({ searchCategory: 'virtual_number_count', from: this.state.numbersFrom, to: this.state.numbersTo })
      .then(resp => { return resp.response.registrationStats })
      .then(resp => {
        let numberData = [];
        resp.forEach(day => {
          let todaysNumberData = {
            created_at: null,
            default: 0,
            similar: 0,
            premium: 0,
            vip: 0,
            respData: day
          };
          for (const key of day.default_number_count) {
            todaysNumberData.default = key.count;
          }
          for (const key of day.similar_number_count) {
            todaysNumberData.similar += key.count;
          }
          for (const key of day.premium_number_count) {
            todaysNumberData.premium += key.count;
          }
          for (const key of day.vip_number_count) {
            todaysNumberData.vip += key.count;
          }
          todaysNumberData.created_at = day.created_at;
          numberData.push(todaysNumberData);
        })
        this.setState({ numberData: numberData });

      })
      .catch(err => {
        console.log('err');
      })
  }

  render() {

    let TodaysPlanData;
    if (this.state.planTodayData) {
      let a = Object.entries(this.state.planTodayData);
      TodaysPlanData = a.map(entry => (
        <tr>
          <td style={{ 'padding': 0 }}>{entry[0]}</td>
          <td style={{ 'padding': 0 }}>{entry[1]}</td>
        </tr>
      ))
    }

    return (
      <div>

        <h1>Plan Data</h1>

        <input
          type="date"
          id="plansFrom"
          value={this.state.plansFrom}
          onChange={this.onChange}
        />
        <input
          type="date"
          id="plansTo"
          value={this.state.plansTo}
          onChange={this.onChange}
        />
        <button onClick={this.getPlansCountHandler}>Search</button>
        <p style={{ 'color': 'red' }}>{this.state.error}</p>






        <div>
          <table style={{ 'marginBottom': '30px' }}>
            <tr>
              <th colspan="2">Today</th>
            </tr>
            <tr>
              <th>Plan</th>
              <th>Count</th>
            </tr>
            {TodaysPlanData}
          </table>

        </div>



        <DynamicTable headerData={this.state.plansTitleList} planList={this.state.planList} tableData={this.state.plansReport} dataType="plans" />
        <hr />
        <h1>Number Type Data </h1>

        <input
          type="date"
          id="numbersFrom"
          value={this.state.numbersFrom}
          onChange={this.onChange}
        />
        <input
          type="date"
          id="numbersTo"
          value={this.state.numbersTo}
          onChange={this.onChange}
        />
        <button onClick={this.getNumbersCountHandler}>Search</button>
        <p style={{ 'color': 'red' }}>{this.state.numberError}</p>
        <DailyCard title="Today" tableData={this.state.todaysNumberData} />

        <DynamicTable headerData={this.state.numberHeaders} tableData={this.state.numberData} dataType="numbers" />
      </div>
    )
  }
}



export default FinPlanComp;


// normalize data 
// convert data to Row
// place data;